<template>
  <v-text-field
    v-on="$listeners"
    v-bind="$attrs"
    :value="value"

    :type="fieldType"
    :append-icon="fieldIcon"
    @click:append="() => togglePassword()"
  />
</template>

<script>
export default {
  name: 'PasswordField',

  inheritAttrs: false,

  // NOTE: "value" must be set as a prop for v-model to work properly
  // @see (https://github.com/vuejs/vue/issues/8430)
  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    showPassword: false,
  }),

  computed: {
    fieldType: (vm) => (vm.showPassword ? 'text' : 'password'),
    fieldIcon: (vm) => (vm.showPassword ? 'mdi-eye' : 'mdi-eye-off'),
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
